@if(showModal){

<main class="modal--overlay" #modalRef (keydown)="onKeyDownModal($event)">
  <button class="invisible-button"></button>
  <section
    class="sl-modal-component-container"
    [ngStyle]="config.width ? { width: config.width } : { width: '50%' }"
  >
    <sl-modal-header
      [closeButton]="config.header.close"
      [backButton]="config.header.back"
      [title]="config.header.title"
      (clickBackEvent)="onClickClose()"
      (clickCloseEvent)="onClickClose()"
    ></sl-modal-header>
    <form [formGroup]="getFormGroup()" (submit)="onSubmit()" id="form-id">
      <sl-modal-body><ng-content></ng-content></sl-modal-body>
    </form>
    <sl-modal-footer
      [linkText]="config.footer.linkText"
      [linkPath]="config.footer.linkPath"
      [primaryButton]="config.footer.primaryButton"
      [secondaryButton]="config.footer.secondaryButton"
      [tertiaryButton]="config.footer.tertiaryButton"
      (primaryButtonEvent)="onClickPrimaryButton()"
      (secondaryButtonEvent)="onClickSecondaryButton()"
      (tertiaryButtonEvent)="onClickTertiaryButton()"
      formId="form-id"
    ></sl-modal-footer>
  </section>
</main>
}
